export function accordion() {

  // アコーディオン
  document.querySelectorAll('.js-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
        const isOpen = toggle.classList.contains('is-open');
        const toggleBody = toggle.nextElementSibling;

        if (isOpen) {
            toggle.classList.remove('is-open');
            if (toggleBody && toggleBody.classList.contains('js-toggle-body')) {
                toggleBody.classList.remove('is-open');
            }
        } else {
            toggle.classList.add('is-open');
            if (toggleBody && toggleBody.classList.contains('js-toggle-body')) {
                toggleBody.classList.add('is-open');
            }
        }
    });
  });

  // 閉じるボタン
  document.querySelectorAll('.js-toggle-close').forEach(function (close) {
    close.addEventListener('click', function () {
        const toggleBody = close.parentElement;
        if (toggleBody && toggleBody.classList.contains('js-toggle-body')) {
            toggleBody.classList.remove('is-open');

            const prevToggle = toggleBody.previousElementSibling;
            if (prevToggle && prevToggle.classList.contains('js-toggle')) {
                prevToggle.classList.remove('is-open');
            }

            // 閉じた後スクロールする
            const jsToggleBodyParent = close.closest('.js-toggle-body');
            if (jsToggleBodyParent) {
                const prevToggle = jsToggleBodyParent.previousElementSibling;
                if (prevToggle && prevToggle.classList.contains('js-toggle')) {
                    prevToggle.scrollIntoView({
                        block: 'start'
                    });
                }
            }
        }
    });
  });

}